import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import Storage from "../../Data/Domain/Storage";

export async function getEmissionCategory() {
  const id = new Storage("id").getItem();
  const year = new Storage("offsetYear").getItem();

  let endpoint = `users/${id}/categories`;

  if (year) {
    endpoint += `?year=${year}`;
  }

  return await new API(URL.buildUrl(endpoint)).get();
}
